export default __webpack_public_path__ + "static/media/title-en.a53a4158.webp";